import React, { useState, useEffect } from 'react'
import "./css/AddActivity.css"
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

import { EditorState } from 'draft-js'

import { Editor } from 'react-draft-wysiwyg'

import LocationOnIcon from '@mui/icons-material/LocationOn'

import DescriptionIcon from '@mui/icons-material/Description'

import { Button, Checkbox, Switch } from '@mui/material';
import TextField from '@mui/material/TextField';


import { DemoContainer } from '@mui/x-date-pickers/internals/demo'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import AccessTimeIcon from '@mui/icons-material/AccessTime'

import axios from 'axios'
import dayjs from 'dayjs'
import api from '../config/backend'

import { DateTimePicker } from '@mui/x-date-pickers'

import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers'

import { SlArrowDown } from 'react-icons/sl'

import { DatePicker } from '@mui/x-date-pickers/DatePicker'

import Popover from '@mui/material/Popover'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { convertToHTML } from 'draft-convert'
import DOMPurify from 'dompurify'

export default function AddActivity({ isDailog, setDailog, leadData, setTriggerRefresh }) {

    const [isModalOpen, setIsModalOpen] = useState(false)

    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedStartTime, setSelectedStartTime] = useState(null);
    const [selectedEndTime, setSelectedEndTime] = useState(null);


    const [checked, setChecked] = useState(false)
    const [isAllDay, setIsAllDay] = useState(true)

    const [openPopover, setOpenPopover] = useState(false)



    const [location, setLocation] = useState("")



    const [selectedColor, setSelectedColor] = useState(null)



    const [inputTitle, setInputTitle] = useState('')



    const predefinedColor = 'rgb(0, 200, 200)'



    const availableColors = [



        "rgb(0, 200, 200)",



        "rgb(250, 216, 207)",



        "rgb(251, 226, 196)",



        "rgb(206, 202, 240)",



        "rgb(200, 200, 200)",



    ]







    const handleOpenPopover = (event) => {



        setOpenPopover(event.currentTarget)



    }







    const handleClosePopover = () => {



        setOpenPopover(null)



    }







    const handleColorSelection = (color) => {



        setSelectedColor(color)







    }



    const handleInputChange = (event) => {



        setInputTitle(event.target.value)



    }





    const openModal = () => {


    };




    const closeModal = () => {

        setDailog(false)

    }



    const handleChange = () => {

        // setChecked(!checked);

        setIsAllDay(!isAllDay)

    }







    const [checkBox, setCheackBox] = useState(false)



    const handleChangeCheckBox = (event) => {

        setCheackBox(event.target.checked)

    }





    const token = localStorage.getItem("_crm__token")
     
    const [convertedContent, setConvertedContent] = useState([])



    useEffect(() => {
        let html = convertToHTML(editorState.getCurrentContent())
        setConvertedContent(html)
    }, [editorState])

    console.log(convertedContent)

    function createMarkup(html) {
        console.log(html)
        return {
            __html: DOMPurify.sanitize(html)
        }
    }
    const [submittedContent, setSubmittedContent] = useState('')
    const [submittedValues, setSubmittedValues] = useState([])
    const handleSave = async () => {
        const newSubmittedContent = editorState.getCurrentContent().getPlainText()
        setSubmittedValues((prevValues) => [...prevValues, newSubmittedContent])
        setSubmittedContent(newSubmittedContent)
        // if (convertedContent === "<p></p>") {
        //     return
        // }
        try {
            if (!inputTitle) {

                toast.error('Please fill in the title field for the activity.', { autoClose: 3000 });
                return;
            }

            if (!isAllDay && (!selectedStartTime || !selectedEndTime)) {

                toast.error('Please select start and end times for the activity.', { autoClose: 3000 });
                return;
            }

            if (isAllDay && !selectedDate) {

                toast.error('Please select a date for the activity.', { autoClose: 3000 });
                return;
            }
           

            if (!newSubmittedContent.trim().length) {
                toast.error('Please write a description for the activity.', { autoClose: 3000 });
                return;
            }
            

            
            let formattedEndDate = null;
            let startdate = null; // Initialize it as null

            if (!isAllDay) {

                startdate = `${selectedStartTime.format('MMM D, YYYY')}, ${selectedStartTime.format(
                    'hh:mm A'
                )}`;
                formattedEndDate = `${selectedStartTime.format('MMM D, YYYY')}, ${selectedEndTime.format('hh:mm A')}`;
            }

            else {
                startdate = selectedDate.format('MMM D, YYYY');
            }
            const requestBody = {
                token,
                hash: leadData.hash,
                title: inputTitle,
                description: convertedContent,
                color: selectedColor || predefinedColor,

                startdate: startdate,
                enddate: formattedEndDate,
                location: location,
                isallday: isAllDay,
                completed: checkBox
            }

            const { data, status } = await axios.post(`${api}/Leads/add-activity`, requestBody)

            if (data.success) {
                toast.success('Activity added successfully.', { autoClose: 3000 })
                setTriggerRefresh(prev => prev + 1)

                setEditorState(EditorState.createEmpty());
                setSelectedDate(dayjs());
                setSelectedStartTime(dayjs());
                setSelectedEndTime(dayjs());
                setChecked(false);
                setOpenPopover(false);
                setLocation("");
                setSelectedColor(null);
                setInputTitle('');
                setDailog('true');
                closeModal();

            } else {
                toast.error(data.message, { autoClose: 3000 })
            }
        } catch (error) {
            toast.error('Error adding activity. Please try again later.', { autoClose: 3000 })
            console.error('Error adding activity', error)
        }

    }

    return (

        <div className="_8sjh">
            <div className={`_1qkl ${isDailog ? 'popup' : ''}`}>

                {isDailog && (

                    <div className="popup">

                        <div className="popup-content">

                            <h2>Add Activity</h2>

                            <div className="_9hrs">

                                <div className="add-title-main-co">

                                    <TextField
                                        className='add-title-input'
                                        id="outlined-multiline-flexible"
                                        label="Add Title"
                                        multiline
                                        maxRows={4}
                                        type="text"
                                        value={inputTitle}
                                        onChange={handleInputChange}
                                    />

                                    {/* <TextField

                                        fullWidth



                                        type="text"



                                        placeholder="Add Title"



                                        value={inputTitle}



                                        onChange={handleInputChange}



                                    /> */}



                                    <div className="color-box" onClick={handleOpenPopover}>



                                        <div className='active-color' style={{ backgroundColor: selectedColor || predefinedColor }}></div>



                                        <div className='arrow-down-col'>



                                            <SlArrowDown />



                                        </div>



                                    </div>



                                </div>







                                <Popover



                                    open={Boolean(openPopover)}



                                    anchorEl={openPopover}



                                    onClose={handleClosePopover}



                                    anchorOrigin={{



                                        vertical: 'bottom',



                                        horizontal: 'left',



                                    }}



                                    PaperProps={{



                                        sx: {



                                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',



                                            background: 'white',



                                            padding: '16px',



                                        },



                                    }}



                                >



                                    <span>Select color</span>



                                    <div className='app-component-picker'>



                                        <ul className='app-component-picker__list'>



                                            {availableColors.map((color, index) => (



                                                <li className='app-component-picker__listitem' key={index}>



                                                    <label



                                                        className='app-component-picker__listitem--label'



                                                        style={{ backgroundColor: color }}



                                                        onClick={() => handleColorSelection(color)}



                                                    >



                                                    </label>



                                                </li>



                                            ))}



                                        </ul>



                                    </div>



                                    <div className='color-pop-footer'>



                                        <Button



                                            size='small'



                                            onClick={handleClosePopover}



                                        >



                                            Done



                                        </Button>



                                    </div>



                                </Popover>

                                <div className="_1lkg">

                                    <DescriptionIcon className='Icons' />

                                    <span> Add Description </span>

                                </div>

                                <div className="_0tou">

                                    <div className="app-component-addnote-1">

                                        <Editor

                                            className="app-component-addnote__editor"

                                            editorState={editorState}

                                            onEditorStateChange={setEditorState}

                                            wrapperClassName="wrapper-class"

                                            editorClassName="editor-class"

                                            toolbarClassName="toolbar-class"

                                            toolbar={{

                                                options: ['inline', 'blockType']

                                            }}

                                        />


                                    </div>

                                </div>
                                {/* <div dangerouslySetInnerHTML={createMarkup(convertedContent)}></div> */}

                            </div>

                            <div className="_4eaf">
                                {isAllDay ? (
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker sx={{ border: 'none', width: "150px", "& fieldset": { border: 'none' } }}
                                                value={selectedDate}
                                                onChange={(newValue) => setSelectedDate(newValue)}
                                            />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                ) : (
                                    <>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                                                <DateTimePicker
                                                    sx={{ border: 'none', width: "150px", "& fieldset": { border: 'none' } }}
                                                    value={selectedStartTime}
                                                    onChange={(newValue) => {
                                                        console.log('selectedStartTime:', newValue)
                                                        setSelectedStartTime(newValue)
                                                    }}

                                                    viewRenderers={{
                                                        hours: renderTimeViewClock,
                                                        minutes: renderTimeViewClock,
                                                        seconds: renderTimeViewClock,
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                                                <DateTimePicker
                                                    sx={{ border: 'none', width: "150px", "& fieldset": { border: 'none' } }}
                                                    value={selectedEndTime}
                                                    onChange={(newValue) => {
                                                        console.log('selectedEndTime:', newValue)
                                                        setSelectedEndTime(newValue)
                                                    }}

                                                    viewRenderers={{
                                                        hours: renderTimeViewClock,
                                                        minutes: renderTimeViewClock,
                                                        seconds: renderTimeViewClock,
                                                    }}
                                                />
                                            </DemoContainer>
                                        </LocalizationProvider>
                                    </>
                                )}
                                <div className='all-day-col'>


                                    <Switch

                                        checked={isAllDay}

                                        onChange={handleChange}

                                        color="warning"

                                        inputProps={{ 'aria-label': 'controlled' }}

                                    />

                                    <span>{isAllDay ? 'All Day' : 'Select Time'}</span>

                                </div>

                            </div>

                            <div className="_8hzo">

                                <LocationOnIcon className='Icons' />

                                <TextField

                                    value={location}

                                    onChange={(e) => setLocation(e.target.value)}

                                    sx={{ marginTop: "10px", }}

                                    label="Location"

                                    fullWidth

                                />

                            </div>
                            <div className='checkbox-mark'>
                                <Checkbox

                                    checked={checkBox}

                                    onChange={handleChangeCheckBox}

                                    inputProps={{ 'aria-label': 'controlled' }}

                                />
                                <p>Mark as done</p>
                            </div>
                            <div className='btn-btnss'>

                                <Button className='app-btn-text' autoFocus onClick={closeModal}>

                                    Cancel

                                </Button>

                                <Button variant='contained' className='app-btn-contained app-btn-primary' autoFocus onClick={handleSave}>

                                    Save changes

                                </Button>

                            </div>

                        </div>

                    </div>

                )}



            </div>
          
        </div>

    )

}